import { tierBlocksAPI } from "./api";

export const getBlocksList = async (params) => {
  try {
    const res = await tierBlocksAPI.getBlocksList(params);
    return res?.data;
  } catch (e) {}
};

export const modifyBlock = async (body, params) => {
  try {
    const res = await tierBlocksAPI.modifyBlock(body, params);
    return res?.data;
  } catch (e) {}
};

export const deleteBlock = async (block_id) => {
  try {
    const res = await tierBlocksAPI.deleteBlock(block_id);
    return res?.data;
  } catch (e) {}
};

export const getEmployees = async () => {
  try {
    const res = await tierBlocksAPI.getEmployees();
    return res?.data;
  } catch (e) {}
};

export const getWorkGroupDict = async () => {
  try {
    const res = await tierBlocksAPI.getWorkGroupDict();
    return res?.data;
  } catch (e) {}
};

export const getResidents = async () => {
  try {
    const res = await tierBlocksAPI.getResidents();
    return res?.data;
  } catch (e) {}
};

export const getWorkGroupsList = async (block_id) => {
  try {
    const res = await tierBlocksAPI.getWorkGroupsList(block_id);
    return res?.data;
  } catch (e) {}
};

export const modifyWorkGroup = async (body) => {
  try {
    const res = await tierBlocksAPI.modifyWorkGroup(body);
    return res?.data;
  } catch (e) {}
};

export const deleteWorkGroup = async (work_group_id) => {
  try {
    const res = await tierBlocksAPI.deleteWorkGroup(work_group_id);
    return res?.data;
  } catch (e) {}
};

export const getWorkGroupDeleteStats = async (work_group_id) => {
  try {
    const res = await tierBlocksAPI.getWorkGroupDeleteStats(work_group_id);
    return res?.data;
  } catch (e) {
    throw e;
  }
};

export const getTasksByWorkGroupDict = async (work_group_dict_id) => {
  try {
    const res = await tierBlocksAPI.getTasksByWorkGroupDict(work_group_dict_id);
    return res?.data;
  } catch (e) {}
};

export const getWorkGroupLevels = async (work_group_id) => {
  try {
    const res = await tierBlocksAPI.getWorkGroupLevels(work_group_id);
    return res?.data;
  } catch (e) {}
};

export const modifyWorkGroupLevel = async (body) => {
  try {
    const res = await tierBlocksAPI.modifyWorkGroupLevel(body);
    return res?.data;
  } catch (e) {
    throw e;
  }
};

export const deleteWorkGroupLevel = async (work_group_level_id) => {
  try {
    const res = await tierBlocksAPI.deleteWorkGroupLevel(work_group_level_id);
    return res?.data;
  } catch (e) {}
};

export const bulkAddWorkGroupLevels = async (body) => {
  try {
    const res = await tierBlocksAPI.bulkAddWorkGroupLevels(body);
    return res?.data;
  } catch (e) {
    throw e;
  }
};

export const deleteWorkGroupTask = async (work_group_id, task_dict_id) => {
  try {
    const res = await tierBlocksAPI.deleteWorkGroupTask(work_group_id, task_dict_id);
    return res;
  } catch (e) {}
};

export const addMissingWorkGroupTasks = async (work_group_id, work_group_dict_id) => {
  try {
    const res = await tierBlocksAPI.addMissingWorkGroupTasks(work_group_id, work_group_dict_id);
    return res;
  } catch (e) {}
};

// Block Employees
export const getBlockEmployees = async (block_id) => {
  try {
    const res = await tierBlocksAPI.getBlockEmployees(block_id);
    return res?.data;
  } catch (e) {}
};

export const addBlockEmployee = async (body) => {
  try {
    const res = await tierBlocksAPI.addBlockEmployee(body);
    return res?.data;
  } catch (e) {
    throw e;
  }
};

export const deleteBlockEmployee = async (block_employee_id) => {
  try {
    const res = await tierBlocksAPI.deleteBlockEmployee(block_employee_id);
    return res?.data;
  } catch (e) {}
};

export const copyBlockEmployees = async (body) => {
  try {
    const res = await tierBlocksAPI.copyBlockEmployees(body);
    return res?.data;
  } catch (e) {
    throw e;
  }
};

export const fullRecalcAll = async () => {
  try {
    const res = await tierBlocksAPI.fullRecalcAll();
    return res?.data;
  } catch (e) {
    throw e;
  }
};

export const getPlanFactAnomalies = async () => {
  try {
    const res = await tierBlocksAPI.getPlanFactAnomalies();
    return res?.data;
  } catch (e) {
    throw e;
  }
};

export const getWorkGroupLevelDetail = async (work_group_id) => {
  try {
    const res = await tierBlocksAPI.getWorkGroupLevelDetail(work_group_id);
    return res?.data;
  } catch (e) {
    return [];
  }
};

export const blocksColumns = [
  {
    name: "resident_name",
    field: "resident_name",
    label: "Проект",
    align: "left",
  },
  {
    name: "block_name",
    field: "block_name",
    label: "Блок",
    align: "center",
  },
  {
    name: "work_groups",
    field: "work_groups",
    label: "Группы работ",
    align: "center",
  },
  {
    name: "",
    field: "",
    label: "",
    align: "left",
  },
];

export const workGroupsColumns = [
  {
    name: "work_group_id",
    field: "work_group_id",
    label: "ID",
    align: "center",
  },
  {
    name: "work_group_name",
    field: "work_group_name",
    label: "Группа работ",
    align: "left",
  },
  {
    name: "date_start",
    field: "date_start",
    label: "Дата начала",
    align: "center",
  },
  {
    name: "date_end",
    field: "date_end",
    label: "Дата окончания",
    align: "center",
  },
  {
    name: "employee_fio",
    field: "employee_fio",
    label: "Сотрудник",
    align: "left",
  },
];
